import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { usePageMetadata } from "../context/PageMetadataContext";
import { horizon } from "../api/horizon";
import CopyIcon from "../components/CopyIcon";
import { timelib } from "../utils/time";
import { Button, Card, Spinner, Table } from "react-bootstrap";
import AccountLabel from "../components/AccountLabel";
import { useLanguage } from "../context/LanguageContext";
import { CardContent } from "../components/Card";
import AdSenseUnit from "../components/AdsenseUnit";
import AdUnit from "../components/AdUnit";

const TransactionsList: React.FC = () => {
  const { t, language } = useLanguage(); // Add language hook
  const [transactions, setTransactions] = useState<any[]>([]);
  const { setHeading, setTitle, setDescription } = usePageMetadata();
  const [txNextLink, setTxNextLink] = useState("");
  const [txPrevLink, setTxPrevLink] = useState("");
  const [txPage, setTxPage] = useState(1);
  const [loading, setLoading] = useState(false);
  
  const fetchTransactions = async (Link = "", page = 1) => {
    try {
      setLoading(true);
      const response = await horizon.getLatestTransactions(Link, 20);
      //if order asc, reverse the array, and next is prev and prev is next
      if (Link==""||Link.indexOf("order=desc") > 0) {
        setTransactions(response._embedded.records);
        setTxNextLink(response._links.next.href);
        setTxPrevLink(response._links.prev.href);
        setTxPage(page);
      }
      else{
        setTransactions(response._embedded.records.reverse());
        setTxNextLink(response._links.prev.href);
        setTxPrevLink(response._links.next.href);
        setTxPage(page);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    // Update metadata with translations
    setHeading(t('transactios.heading'));
    setTitle(t('transactions.title'));
    setDescription(t('transactions.description'));
  }, [setTitle, setDescription, setHeading, t, language]);
  
  useEffect(() => {
    fetchTransactions();
  }, []);

  // Format amount based on user's locale
  const formatAmount = (amount: number): string => {
    return amount.toLocaleString(language, { 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 3 
    });
  };

  return (
    <div className="white-zone">
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <div>
            <div className="col-md-12">
                <Card className="none-radius">
                    <CardContent>
                        <h5 className="card-title" style={{fontSize:"16px",marginBottom:"20px"}}>{t('transactions.title')}</h5>
          <Table hover responsive className="mt-3">
            <thead>
              <tr>
                <th>{t('transaction.hash')}</th>
                <th>{t('transaction.source_account')}</th>
                <th>{t('transaction.operation_count')}</th>
                <th>{t('transaction.fee')}</th>
                <th>{t('block.sequence')}</th>
                <th>{t('transaction.created_at')}</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((tx) => (
                <tr key={tx.id}>
                  <td>
                    <Link to={`/tx/${tx.hash}`} className="text-decoration-none">
                      {tx.hash.slice(0, 16)}...
                    </Link>{" "}
                    <CopyIcon textToCopy={tx.hash} />
                  </td>
                  <td>
                    <Link
                      to={`/account/${tx.source_account}`}
                      className="text-decoration-none"
                    >
                      <AccountLabel account={tx.source_account} shorten={true}/>
                    </Link>{" "}
                    <CopyIcon textToCopy={tx.source_account} />
                  </td>
                  <td>{tx.operation_count}</td>
                  <td>{formatAmount(tx.fee_charged / 10_000_000)} π</td>
                  <td>
                    <Link
                      to={`/block/${tx.ledger}`}
                      className="text-decoration-none"
                    >
                      {formatAmount(tx.ledger)}
                    </Link>
                  </td>
                  <td>{timelib.timeAgo(tx.created_at, language)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="d-flex justify-content-between align-items-center mt-4">
            <Button
              size="sm"
              variant="primary"
              onClick={() => fetchTransactions(txPrevLink, txPage - 1)}
              disabled={!txPrevLink || loading || txPage === 1}
            >
              {t('pagination.previous')}
            </Button>
            <span className="mx-3">{t('pagination.page')} {txPage}</span>
            <Button
              size="sm"
              variant="primary"
              onClick={() => fetchTransactions(txNextLink, txPage + 1)}
              disabled={!txNextLink || loading}
            >
              {t('pagination.next')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
    <div className="row g-3 mb-4  d-block d-md-none">
        {/* <AdSenseUnit/> */}
        {/* <AdUnit
                  className="67cc9f95aa72d3d47fe128c2"
                  width="300px"
                  height="100px"
                  centered={true}
                /> */}
      </div>
  </div>
      )}
    </div>
  );
};

export default TransactionsList;
